module.exports = "pegasus_template/assets/themelp1/design/101.png";